import * as React from 'react';
import { FormField } from './FormField';

type StaticTextFieldProps = {
    label:string,
    inErrorState?:boolean,
    infoMessage?:string,
    staticText:string
};

export function StaticTextField(props:StaticTextFieldProps)
{
    return (
        <FormField
            label={props.label} 
            inputComponent={
                <div>{props.staticText}</div>
            }
            inErrorState={props.inErrorState}
            message={props.infoMessage}
        />
    )
}